module.exports = __webpack_public_path__ + "img/setToTop.4861ee11.png";